import React from "react";

import BreadCrumb from "@/Components/Common/BreadCrumb";
import { Container } from "@/Components/ui";

import TerminalSettingsPanel from "./TerminalSettingsPanel";

const Terminals = () => {
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="POS 단말 관리" pageTitle="현장주문" />
        <TerminalSettingsPanel />
      </Container>
    </div>
  );
};

export default Terminals;